import { VisualizatorSettings } from "./visualizator-settings";

export class VisualizatorSettingsArray extends VisualizatorSettings {
  constructor(settingsArray) {
    super();
    this.settings = [];
    for (let i = 0; i < settingsArray.length; i++) {
      this.settings.push(settingsArray[i].copy());
    }
  }

  copy() {
    return new VisualizatorSettingsArray(this.settings);
  }
}
